import mapValues from 'lodash/mapValues';
// import {LOAD} from 'redux-storage'
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import {languageReady} from '../../_libs/angular-translate-redux';
import {AbstractEpics} from '../../core-utilities/redux/AbstractEpics';
import {translateMessages} from '../utils';
import {epicErrorHandler} from '../../core-utilities/rx-utils';

export class TodoMessageReduxListEpics extends AbstractEpics {

  /**
   * @param {TodoMessageReduxList} reduxList
   */
  constructor(reduxList) {
    super(reduxList.options);

    this.options = reduxList.options;
    this.actions = reduxList.actions;

    this.onLanguageChange = this.onLanguageChange.bind(this);
    this.onLanguageChange.$inject = ['$translate'];
    this.addEpic(this.onLanguageChange);
  }

  /**
   * Recalculate the messages in the list after the language has changed
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param dependencies
   * @return {Observable.<ReduxAction>}
   */
  onLanguageChange(action$, store, dependencies) {
    return action$.ofType(languageReady.TYPE)
      .mergeMap(() => {
        const $translate = dependencies.$translate;
        let total = 0;
        const state = this.options.getState(store.getState());
        const list = mapValues(state.list, item => (total++, translateMessages(item, $translate, this.logger)));

        return total > 0 ? Observable.of(this.actions.updateI18n({list})) : Observable.empty();
      })
      .catch(epicErrorHandler(this.logger, 'onLanguageChange'));
  }
}



// WEBPACK FOOTER //
// ./src/js/todo-messages/redux/todoMessageEpics.js